import { useTranslation } from "react-i18next";
import {
  Tag,
  Toggletip,
  ToggletipButton,
  ToggletipContent,
} from "@carbon/react";
import { Information } from "@carbon/icons-react";
import "./offerAssistant.scss";

type Props = {
  /** Tag text (i18n key); defaults to "Recomendada por IA". */
  labelKey?: string;
  reason: string;
};

/** Purple "Recomendada por IA" tag for the award matrix, with the assistant's reason on demand. */
const AiRecommendedTag = ({
  labelKey = "offerAssistant.recommendedTag",
  reason,
}: Props) => {
  const { t } = useTranslation();
  return (
    <span className="ai-recommended-tag">
      <Tag type="purple" size="sm">
        {t(labelKey)}
      </Tag>
      {reason && (
        <Toggletip align="bottom" autoAlign>
          <ToggletipButton label={t("offerAssistant.reasonLabel")}>
            <Information size={16} />
          </ToggletipButton>
          <ToggletipContent>
            <p className="ai-recommended-tag__reason">{reason}</p>
          </ToggletipContent>
        </Toggletip>
      )}
    </span>
  );
};

export default AiRecommendedTag;
